module.exports = __webpack_public_path__ + "img/IT.48651b91.svg";